import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "right-parenthesis",
  "use": "right-parenthesis-usage",
  "viewBox": "0 0 19 30",
  "content": "<symbol viewBox=\"0 0 19 30\" xmlns=\"http://www.w3.org/2000/svg\" id=\"right-parenthesis\"><path d=\"M0 30h3.994C12.28 30 19 23.286 19 15 19 6.716 12.283 0 3.994 0H0c5.354 2.863 8.996 8.506 8.996 15 0 6.495-3.642 12.137-8.996 15z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/svg/right-parenthesis.svg
// module id = 594
// module chunks = 0